import { ChatType } from '../components/chat-list-section/chat-row/typings';

const colors: { [key: string]: string } = {
  '0': '#c4616b',
  '1': '#c06382',
  '2': '#ae5fc0',
  '3': '#8959e5',
  '4': '#596bd7',
  '5': '#4d90cc',
  '6': '#317694',
  '7': '#3e9892',
  '8': '#57af5c',
  '9': '#7fa453',
};

const colorValues = Object.values(colors);

/** Derives a color from any string identifier (name, username, etc.) using char-code hashing. */
export const getColorFromIdentifier = ({
  identifier,
  chatType,
  lighter = false,
}: {
  identifier: string;
  chatType?: ChatType;
  lighter?: boolean;
}) => {
  try {
    if (chatType === ChatType.GROUP) return lighter ? '#29B6F622' : '#29B6F6';

    if (!identifier.length) return lighter ? '#F0F4C322' : '#F0F4C3';

    const hash = identifier.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);

    const color = colorValues[hash % colorValues.length];
    return lighter ? `${color}22` : color;
  } catch {
    return lighter ? '#F0F4C322' : '#F0F4C3';
  }
};

export const getColorFromPhone = ({
  phone,
  name,
  chatType,
  lighter = false,
}: {
  phone: string;
  name: string;
  chatType?: ChatType;
  lighter?: boolean;
}) => {
  try {
    if (chatType === ChatType.GROUP) return !lighter ? '#29B6F6' : '#29B6F622';

    if (!phone.length || !name.length) return !lighter ? '#F0F4C3' : '#F0F4C322';

    const lastDigit = phone[phone.length - 1];

    return colors[lastDigit];
  } catch (error) {
    return !lighter ? '#F0F4C3' : '#F0F4C322';
  }
};
